import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UnlServiceService } from 'src/app/services/unl-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  menus: any;
  environmentType = environment.environmentType;

  constructor( public unlService: UnlServiceService,private router: Router) { }

  ngOnInit() {
   this.menus = this.unlService.menus;
  }

  toggleMenu() {
    var nav = document.getElementById("nav-links");
    nav.classList.toggle("active");
  }

  menuclick(menu: any) : void {
    this.router.navigate(['/', menu.link, 'all']);
  }

}
